const styles = `
    html {
        background-color: var(--REPLACEME);
        color: var(--REPLACEME);
        font-family: 'Relative Book', 'Relative Book Fallback';
    }
`;
export default styles;
